import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=2f62eb1a&scoped=true&"
import script from "./Importer.vue?vue&type=script&lang=js&"
export * from "./Importer.vue?vue&type=script&lang=js&"
import style0 from "./Importer.vue?vue&type=style&index=0&id=2f62eb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62eb1a",
  null
  
)

export default component.exports